import React from 'react'
import logo from '../assets/img/logo-white.png'
import '../App.scss'

const BlockedPage = () => {
	return (
		<div
			style={{
				minHeight: '100vh',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
				padding: '20px',
				textAlign: 'center',
			}}
		>
			<div
				style={{
					background: 'rgba(255, 255, 255, 0.1)',
					backdropFilter: 'blur(10px)',
					borderRadius: '20px',
					padding: '60px 40px',
					maxWidth: '500px',
					boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)',
					border: '1px solid rgba(255, 255, 255, 0.18)',
				}}
			>
				<img
					src={logo}
					alt="Couleur Cuisine"
					style={{
						width: '250px',
						marginBottom: '40px',
						filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.3))',
					}}
				/>

				<div
					style={{
						fontSize: '32px',
						fontWeight: 'bold',
						color: '#fff',
						marginBottom: '20px',
						letterSpacing: '1px',
					}}
				>
					Website is Blocked
				</div>

				<div
					style={{
						fontSize: '16px',
						color: 'rgba(255, 255, 255, 0.8)',
						lineHeight: '1.6',
						marginBottom: '10px',
					}}
				>
					This website is blocked. Contact the administrator for more
					information.
				</div>

				<div
					style={{
						fontSize: '14px',
						color: 'rgba(255, 255, 255, 0.6)',
						marginTop: '20px',
					}}
				>
					Ce site est bloqué. Contactez l'administrateur pour plus
					d'informations.
				</div>
			</div>
		</div>
	)
}

export default BlockedPage
